// extracted by mini-css-extract-plugin
export default {"column":"index_column_5hkaW"};